import { asStore } from '@src/application/store/as-store.ts';
import { ref, watch } from 'vue';
import { User } from '@src/user/interfaces/user.ts';
import apiClient from '@src/api/api-client.ts';

export function useCurrentUserComposable() {
    const currentUser = asStore('currentUser', () => ref<User|null>(null), false);
    if (currentUser.value === null) {
        loadCurrentUser();
    }

    watch(currentUser, () => {
        if (currentUser.value !== null) {
            return;
        }
        loadCurrentUser();
    }, { immediate: true });

    function loadCurrentUser() {
        return apiClient.get('/be/me')
            .then(({ data }) => {
                currentUser.value = data;
            });
    }

    return {
        currentUser,
    };
}
